/** Strip internal config keys from messages shown to end users. */

const INTERNAL_PATTERNS: RegExp[] = [
  /stripe[_\s-]?secret[_\s-]?key/gi,
  /STRIPE_[A-Z_]+/g,
  /api[_\s-]?key/gi,
  /not configured/gi,
  /environment variable/gi,
  /VITE_[A-Z0-9_]+/g,
  /detail:\s*/gi,
];

export function sanitizeUserFacingMessage(raw: string, fallback: string): string {
  const text = (raw || '').trim();
  if (!text) return fallback;
  if (INTERNAL_PATTERNS.some((re) => re.test(text))) {
    return fallback;
  }
  return text;
}

export function sanitizeBillingError(raw: string): string {
  return sanitizeUserFacingMessage(
    raw,
    'Payments are temporarily unavailable. You can still create — upgrades will return soon.',
  );
}

export function sanitizeAuthError(raw: string): string {
  const text = (raw || '').trim();
  if (/project_provider_disabled|provider is disabled|412/i.test(text)) {
    return 'Google sign-in is temporarily unavailable. Use email and password, or try again in a moment.';
  }
  return sanitizeUserFacingMessage(
    text,
    'Sign-in failed. Check your email and password, or reset your password below.',
  );
}
